export const ALLOWED_EXTENSIONS = new Set([
  "txt",
  "pdf",
  "png",
  "jpg",
  "jpeg",
  "gif",
  "csv",
  "doc",
  "docx",
  "epub",
  "json",
  "html",
  "mp3",
  "mp4",
  "pptx",
  "xlsx",
  "xls",
]);

export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 MB

export const getFileExtension = (name) =>
  (name || "").split(".").pop().toLowerCase();

export const validateFile = (file) => {
  const ext = getFileExtension(file.name);
  if (!ALLOWED_EXTENSIONS.has(ext)) {
    return `Unsupported file type: .${ext}`;
  }
  if (file.size > MAX_FILE_SIZE) {
    return `File too large (max 10 MB): ${file.name}`;
  }
  return null;
};
